<template>
  <div class="orderdet content_center">
    <div class="mtb20 ft12 C787878">
      <span>您现在的位置：</span>
      <span>
        <a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a>
      </span>
      <span class="el-icon-arrow-right"></span>
      <span>订单详情</span>
    </div>
    <div class="orderdet_title">订单详情</div>
    <div>
      <div class="row-container">
        <p class="lineheight30">
          <span class="C787878 inline_block ">订单编号：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.orderCode }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">下单时间：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.createDate }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">供货方式：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.ext1Name }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">配送方式：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.pickTypeName }}</span>
        </p>
      </div>
      <div class="row-container">
        <p class="lineheight30">
          <span class="C787878 inline_block ">运输方式：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.ext2Name }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">发票类型：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.ext3Name }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">实际支付：</span>
          <span class="D1D1D1 inline_block">￥{{ orderInfo.actualAmount }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">订单总金额：</span>
          <span class="D1D1D1 inline_block">
            ￥{{orderInfo.amount}}
            <!-- {{ orderInfo.promotionAmount + orderInfo.repAmount + orderInfo.discountAmount }} -->
          </span>
        </p>
      </div>
      <div class="row-container">
        <p class="lineheight30">
          <span class="C787878 inline_block ">政策优惠金额：</span>
          <span class="D1D1D1 inline_block">￥{{ orderInfo.promotionAmount }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">返利及现金垫付抵扣金额（元）：</span>
          <span class="D1D1D1 inline_block">￥{{ orderInfo.discountAmount }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">使用货补费用（元）：</span>
          <span class="D1D1D1 inline_block">￥{{ orderInfo.repAmount }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">收货人：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.contactsName }}</span>
        </p>
      </div>
      <div class="row-container">
        <p class="lineheight30">
          <span class="C787878 inline_block ">收货电话：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.contactsPhone }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">收货地址：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.pickAdress }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">订单总重量：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.weightOfKilogram }}</span>
        </p>
        <p class="lineheight30">
          <span class="C787878 inline_block ">备注：</span>
          <span class="D1D1D1 inline_block">{{ orderInfo.remarks }}</span>
        </p>
      </div>
      <!-- <el-table :header-cell-style="{ textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
                :cell-style="{fontSize:'14px',color:'#1D1D1D'}"
                :data="tableData1"
                style="width: 100%">
        <el-table-column width="400px"
                         label="订单信息">
          <template>
            <p class="lineheight30"><span class="C787878 inline_block w100">订单编号：</span><span class="D1D1D1 inline_block">{{orderInfo.orderCode}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">下单时间:</span><span class="D1D1D1 inline_block">{{orderInfo.createDate}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">客户名称：</span><span class="D1D1D1 inline_block">{{orderInfo.cusName}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">收货人：</span><span class="D1D1D1 inline_block">{{orderInfo.contactsName}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">联系电话：</span><span class="D1D1D1 inline_block">{{orderInfo.contactsPhone}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">收货地址：</span><span class="D1D1D1 inline_block">{{orderInfo.pickAdress}}</span></p>
          </template>
        </el-table-column>
        <el-table-column width="250px"
                         label="结算信息">
          <template>
            <p class="lineheight30"><span class="C787878 inline_block w100">商品总数：</span><span class="D1D1D1">{{orderInfo.productNum}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">优惠总金额：</span><span class="D1D1D1">￥{{orderInfo.promotionAmount}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">使用费用：</span><span class="D1D1D1">￥{{orderInfo.repAmount}}</span></p>
            <p class="lineheight30"><span class="C787878 inline_block w100">实际支付：</span><span class="D1D1D1">￥{{orderInfo.actualAmount}}</span></p>
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
        
        </el-table-column>
      </el-table> -->
    </div>
    <div class="mtb20">
      <div v-for="(items, k) in tableData" :key="k" :ref="items.key || 'productList'">
        <el-table
          :show-header="k != 0 ? false : true"
          :header-cell-style="{
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
            textAlign: 'center'
          }"
          :cell-style="{ fontSize: '14px', textAlign: 'center', padding: '20px 0px' }"
          :row-key="getRowKey"
          :data="items.data"
          align="center"
          tooltip-effect="dark"
          style="width: 100%;border:1px solid #D8D8D8;border-bottom:0px;margin-top:20px;"
        >
          <el-table-column
            :width="item.props.width"
            :label="item.props.title || item.title"
            v-for="(item, index) in tableList"
            :key="index"
          >
            <template slot-scope="scope">
              <div v-if="item.field === 'productName'">
                <!-- 本品商品 -->
                <div class="flex" slot="reference">
                  <div class="">
                    <el-image style="width:90px;height:90px" :src="scope.row.imgUrl"></el-image>
                  </div>
                  <div class="textleft ft14 ml20">
                    <p class="overflow_ellipsis2">{{ scope.row.productName }}</p>
                    <p class="mt20">
                      <span>商品编码：</span>
                      <span>{{ scope.row.productCode }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div v-else-if="item.field === 'productNum'">
                <div>
                  {{ scope.row.productNum }}
                </div>
              </div>
              <div
                class="flex"
                v-else-if="item.field === 'promotionList'"
                style="width:100%;justify-content:center"
              >
                <div v-if="scope.row.lineType === '0'">
                  <div
                    class="tag-box"
                    v-if="scope.row.promotionList && scope.row.promotionList.length > 0"
                  >
                    <div v-for="(pro, i) in scope.row.promotionList" :key="i">
                      <el-tag
                        size="small"
                        :type="pro.calSucessMs ? 'danger' : 'success'"
                        slot="reference"
                        class="pro-tag"
                        @click="promotionDetail(pro.promotionCode, scope.row.productCode)"
                      >
                        {{ pro.promotionName }}
                      </el-tag>
                    </div>
                  </div>
                  <div v-else>
                    --
                  </div>
                </div>
              </div>
              <div class="flex" v-else>
                <span slot="reference">{{ analysisField(scope, item) }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="btn">
      <el-button @click="goHomes" size="small" type="primary">返回</el-button>
    </div>
    <!-- 促销政策右侧弹框 -->
    <ShopsettleReplenDrawer
      :visible.sync="visible"
      :promotionParams="promotionParams"
      :promotionCode="promotionCode"
      @handleClose="handleClose"
    />
  </div>
</template>
<script>
import { orderDetail, getTableConfig, getBatchDictSelect } from '@/api/api'
import ShopsettleReplenDrawer from './ShopsettleReplenDrawer'
import { Storage } from "@/utils/storage";
import cals from '@/views/ShopSettle/js/cals'
export default {
  name: 'orderdet',
  components: { ShopsettleReplenDrawer },
  data() {
    return {
      orderInfo: {
        orderCode: '',
        createDate: '',
        cusName: '',
        contactsName: '',
        contactsPhone: '',
        pickAdress: '',
        productNum: '',
        promotionAmount: '',
        repAmount: '',
        actualAmount: '',
        ext1: '', //订单供货方式
        ext1Name: '', //供货方式Name
        ext2: '', //订单运输方式
        ext2Name: '', //运输方式name
        ext3: '', //发票类型
        ext3Name: '', //发票类型name
        pickType: '', //配送方式
        pickTypeName: ''
      },
      orderStatus: {
        state: 0,
        date1: '',
        date2: '',
        date3: '',
        date4: '',
        date5: '',
        active: 2
      }, //订单状态
      tableData: [],
      tableData1: [{}],
      tableList: [],
      shippingMethodList: [],
      transportTypeList: [],
      invoiceTypeList: [],
      pickTypeList: [],
      visible: false,
      promotionParams: null,
      promotionCode: []
    }
  },
  methods: {
    // 解析字段
    analysisField(scope, item) {
      if (item.field === 'lineType') {
        if (scope.row.lineType === '1') {
          return '政策商品'
        }
        if (scope.row.lineType === '2') {
          return '货补'
        }
        if (scope.row.lineType === '3') {
          return '补货'
        }
        return '本品'
      }
      return scope.row[item.field]
    },
    getRowKey(row) {
      return row.id
    },
    //   获取列表配置
    getTableConfig() {
      const params = {
        functionCode: 'dms_order_settle_table',
        function_code: 'dms_order_settle_table',
        parentCode: 'CRM20210129000000857_1'
      }
      getTableConfig(params).then((res) => {
        const tableList = []
        res.result.column.filter(v => v.visible).forEach((v) => {
          const rowData = v
          rowData.props = this.mateFieldType(rowData.field, rowData.title)
          if (!rowData.props.hidden) {
            tableList.push(rowData)
          }
        })
        this.tableList = tableList
      })
    },

    mateFieldType(field, title) {
      let rowProps = {
        align: 'center',
        showOverflowTooltip: true,
        // width: '100px',
      }
      switch (field) {
        case 'promotionList':
          rowProps = {
            ...rowProps,
            width: '180px'
          }
          break
        case 'productName':
          rowProps = {
            ...rowProps,
            title: '商品名称/编码',
            width: '290px'
          }
          break
        case 'productNum':
          rowProps = {
            ...rowProps,
            width: '150px'
          }
          break
        case 'productCode':
          rowProps = {
            ...rowProps,
            hidden: true
          }
          break
      }

      return rowProps
    },
    getOrderDetail() {
      let { id } = { ...this.$route.query }
      orderDetail(id)
        .then((res) => {
          if (res.code === 200 && res.result) {
            const tableData = cals.handleCalData(res.result.groupItemVos)
            this.tableData = tableData
            this.orderInfo = res.result
            console.log(res, '查看')
            this.getBatchDictSelect()
            // this.produceList = res.result.groupItemVos[0].normalList;
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 返回上一页
    goHomes() {
      // window.history.back()
      this.$router.back()
    },
    // 获取数据字典
    getBatchDictSelect() {
      const params = [
        'dms_order_type',
        'dms_order_pick_type',
        'dms_shipping_method',
        'dms_transport_type',
        'mdm_terminal_ka_bill_type',
        'hd_order_start_ship_quantity'
      ]
      getBatchDictSelect(params).then((res) => {
        if (res.success) {
          // res.result.dms_order_type.forEach((v) => {
          //   this.orderTypeList.push({
          //     label: v.dictValue,
          //     value: v.dictCode
          //   })
          //   this.info.orderType = '1'
          // })
          res.result.dms_order_pick_type.forEach((v) => {
            this.pickTypeList.push({
              label: v.dictValue,
              value: v.dictCode
            })
          })
          this.shippingMethodList = res.result.dms_shipping_method.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })
          this.transportTypeList = res.result.dms_transport_type.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })
          this.invoiceTypeList = res.result.mdm_terminal_ka_bill_type.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })
          this.hdOrderStartShipQuantity = res.result.hd_order_start_ship_quantity.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })

          if (this.orderInfo.ext1) {
            this.getName(this.orderInfo.ext1, 'ext1', 'shippingMethodList')
          }
          if (this.orderInfo.ext2) {
            this.getName(this.orderInfo.ext2, 'ext2', 'transportTypeList')
          }
          if (this.orderInfo.ext3) {
            this.getName(this.orderInfo.ext3, 'ext3', 'invoiceTypeList')
          }
          if (this.orderInfo.pickType) {
            this.getName(this.orderInfo.pickType, 'pickType', 'pickTypeList')
          }
        }
      })
    },
    //获取下拉框选中项名称
    getName(val, field, data) {
      if (val) {
        this.orderInfo[`${field}Name`] = this[data].find((item) => item.value === val).label
      } else {
        this.orderInfo[`${field}Name`] = ''
      }
      console.log(this.orderInfo)
      this.orderInfo = JSON.parse(JSON.stringify(this.orderInfo))
    },
    //获取促销政策详情
    promotionDetail(promotionCode, productCode) {
      this.visible = true
      this.promotionCode = [promotionCode]
      this.promotionParams = {
        accountCode: Storage.l.get('customerCode'),
        accountType: 'customer',
        saleProductVos: [{ productCode }]
      }
      console.log(this.promotionParams)
    },
    //关闭促销政策弹窗
    handleClose() {
      this.visible = false
    }
  },

  created() {
    this.getTableConfig()
    this.getOrderDetail()
  }
}
</script>
<style lang="scss" scoped>
.orderdet {
  .row-container {
    display: flex;
    p {
      width: 25%;
    }
  }
  .orderdet_title {
    font-size: 28px;
    color: #1d1d1d;
    margin-bottom: 20px;
  }
  // 不垂直居中
  /deep/ .el-table {
    margin-bottom: 40px;
    td {
      vertical-align: top; //让表格内容不垂直居中
    }
  }
  // 设置进度条样式
  /deep/ .el-step.is-center .el-step__description {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .content_header {
    display: flex;
    flex-wrap: wrap;
    div {
      // min-width: 16%;
      justify-content: space-between;
      margin-bottom: 10px;
      margin-right: 20px;
    }
    div:last-child {
      width: 100%;
    }
  }
  .btn {
    display: flex;
    margin: 20px 0px;
    justify-content: flex-end;
  }
}
</style>
